var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.27 23.47c-7.215-6.204-23.18-9.277-35.14-.37C53.905 30.595 53.35 44.292 53.35 44.292c1.912 7.494 9.496 14.68 24.11 11.18-1.726-10.074 1.657-35.563 22.81-32z",
    fill: "#00acd2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.755 47.835C84.86 54.36 60.83 64.32 53.35 44.293c-1.786 9.326 3.17 24.848 16.896 30.714 12.127 5.935 24.765-.94 24.765-.94 5.56-5.396 8.095-15.377-2.257-26.234",
    fill: "#c8e9eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.495 38.68c9.622 3.547 30.19 18.922 16.516 35.387 9-3.122 19.556-15.068 17.794-29.84-.904-13.43-12.535-20.756-12.535-20.756-7.47-2.098-17.512.852-21.775 15.2",
    fill: "#662d91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppium);
export default __webpack_public_path__ + "static/media/Appium.2a45bbd343ac35bea961efb99877bdb6.svg";
export { ForwardRef as ReactComponent };